module.exports = { "default": require("core-js/library/fn/object/get-prototype-of"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/.npminstall/babel-runtime/6.11.6/babel-runtime/core-js/object/get-prototype-of.js
 ** module id = 21
 ** module chunks = 0
 **/